<template>
  <v-card dark toolbar class="organization photos">
    <v-toolbar class="transparent elevation-0 my-3">
      <div class="headline">Photo Gallery</div>
      <v-spacer />
      <can I="edit" a="Organization">
        <v-menu left bottom :close-on-content-click="false" v-model="adding">
          <v-btn round slot="activator" color="secondary">
            <v-icon left>mdi-plus</v-icon> Add Photo
          </v-btn>
          <v-card width="600px">
            <v-form v-model="valid">
              <v-card-text>
                <v-btn block @click="$refs.file.click()" color="secondary">
                  Select Image
                </v-btn>
                <input
                  type="file"
                  name="file"
                  ref="file"
                  @change="setFile"
                  style="display: none;"
                />

                <v-text-field label="Caption" v-model="photo.caption" />
              </v-card-text>

              <v-card-actions>
                <v-btn flat block @click="cancel" color="grey">Cancel</v-btn>
                <v-btn block @click="create" :disabled="!photo.image" color="primary">
                  Add
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-menu>
      </can>
    </v-toolbar>

    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex v-for="photo in organization.photos" :key="`photo-${photo.id}`" xs12 md6 d-flex>
          <OrganizationPhoto :organization="organization" :photo="photo" @remove="remove(photo)" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
// Components
import OrganizationPhoto from '@/components/organizations/OrganizationPhoto'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { OrganizationPhoto },

  data() {
    return {
      adding: false,
      valid: false,
      photo: {
        caption: '',
        image: null,
      },
      rules: {
        image: [v => !!v || 'You must provide an image'],
      },
    }
  },
  computed: mapGetters({
    organization: 'admin/organizations/find',
  }),
  methods: {
    add() {
      this.adding = true
    },
    cancel() {
      this.adding = false
      this.photo.caption = ''
      this.photo.image = null
    },
    setFile() {
      this.photo.image = this.$refs.file.files[0]
    },
    create() {
      let photoData = new FormData()
      photoData.append('image', this.photo.image)
      photoData.append('caption', this.photo.caption)
      this.$store
        .dispatch('admin/organizations/createPhoto', {
          organization: { id: this.organization.id },
          photoData,
        })
        .then(this.cancel)
    },
    remove(photo) {
      this.$store.dispatch('admin/organizations/removePhoto', {
        organization: { id: this.organization.id },
        photo: { id: photo.id },
      })
    },
  },
}
</script>

<style lang="scss">
.organization.photos {
  .with-scrim {
    text-shadow: 0 0 2px black, 0 0 4px black;

    .v-image__image::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0.5) 30%,
        rgba(0, 0, 0, 0.2) 100%
      );
    }
  }
}
</style>
